import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "e215391a-7b40-40de-bbc7-12ae526da1ef",
  publicId: "18",
  name: "Electrodynamic moving coil loudspeaker",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
